import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import useTranslation from '../../hooks/useTranslation';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200"
      aria-label="Toggle language"
    >
      <Globe className="h-4 w-4" />
      <span>{language === 'en' ? t('language.es') : t('language.en')}</span>
    </button>
  );
};

export default LanguageToggle;
